export default __webpack_public_path__ + "static/media/search-icon.603a6514.svg";